import { Configuration, LogLevel } from '@azure/msal-browser';

import { FRONTEND_ENV } from '@frontend/const/const.FRONTEND_ENV';

export const msalConfig: Configuration = {
  auth: {
    clientId: FRONTEND_ENV.VITE_AZURE_AD_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${FRONTEND_ENV.VITE_AZURE_AD_TENANT_ID}/v2.0`,
    redirectUri: `${window.location.origin}/auth/callback`,
    postLogoutRedirectUri: '/',
  },
  cache: {
    cacheLocation: 'localStorage',
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          default:
            break;
        }
      },
      logLevel: LogLevel.Info,
    },
  },
};

export const loginRequest = {
  scopes: [
    `api://${FRONTEND_ENV.VITE_AZURE_AD_CLIENT_ID}/access_as_user`,
    'openid',
    'profile',
    'email',
  ],
};

export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
  graphGroupsEndpoint: 'https://graph.microsoft.com/v1.0/me/memberOf',
};
